import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const GDPRModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="gdpr-modal-overlay" onClick={onClose}>
      <div className="gdpr-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="gdpr-modal-close" onClick={onClose} aria-label="Cerrar">
          ×
        </button>
        <h2 className="gdpr-modal-title">Política de Privacidad</h2>
        <div className="gdpr-modal-body">
          <section>
            <h3>1. Responsable del Tratamiento</h3>
            <p>
              Myntar, con domicilio en España, es el responsable del tratamiento de los datos personales 
              que nos proporcione a través de este formulario de contacto.
            </p>
          </section>

          <section>
            <h3>2. Finalidad del Tratamiento</h3>
            <p>
              Los datos personales que nos proporcione serán utilizados exclusivamente para:
            </p>
            <ul>
              <li>Responder a su consulta o solicitud de información</li>
              <li>Mantener comunicación relacionada con su consulta</li>
              <li>Enviarle información sobre nuestros servicios, si así lo ha solicitado</li>
            </ul>
          </section>

          <section>
            <h3>3. Base Legal</h3>
            <p>
              El tratamiento de sus datos personales se basa en su consentimiento explícito, que puede 
              retirar en cualquier momento sin que ello afecte a la licitud del tratamiento realizado 
              con anterioridad.
            </p>
          </section>

          <section>
            <h3>4. Conservación de Datos</h3>
            <p>
              Conservaremos sus datos personales durante el tiempo necesario para cumplir con la finalidad 
              para la que fueron recabados y, en cualquier caso, durante los plazos legalmente establecidos.
            </p>
          </section>

          <section>
            <h3>5. Derechos del Usuario</h3>
            <p>Usted tiene derecho a:</p>
            <ul>
              <li><strong>Acceso:</strong> Obtener información sobre sus datos personales que tratamos</li>
              <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos</li>
              <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos cuando ya no sean necesarios</li>
              <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos personales</li>
              <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento en determinadas circunstancias</li>
              <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado y de uso común</li>
              <li><strong>Retirar el consentimiento:</strong> En cualquier momento, sin afectar la licitud del tratamiento previo</li>
            </ul>
            <p>
              Para ejercer estos derechos, puede contactarnos en: <strong>contact@myntar.io</strong>
            </p>
          </section>

          <section>
            <h3>6. Seguridad</h3>
            <p>
              Implementamos medidas técnicas y organizativas apropiadas para proteger sus datos personales 
              contra el acceso no autorizado, la pérdida, destrucción o alteración.
            </p>
          </section>

          <section>
            <h3>7. Transferencias Internacionales</h3>
            <p>
              Sus datos personales se procesan dentro del Espacio Económico Europeo (EEE) y cumplen con 
              el Reglamento General de Protección de Datos (RGPD).
            </p>
          </section>

          <section>
            <h3>8. Modificaciones</h3>
            <p>
              Nos reservamos el derecho de modificar esta política de privacidad. Le notificaremos cualquier 
              cambio significativo a través de nuestro sitio web.
            </p>
          </section>

          <section>
            <h3>9. Contacto</h3>
            <p>
              Para cualquier consulta relacionada con el tratamiento de sus datos personales, puede contactarnos en:
            </p>
            <p>
              <strong>Email:</strong> contact@myntar.io<br />
              <strong>Asunto:</strong> Protección de Datos
            </p>
          </section>

          <p className="gdpr-modal-date">
            <em>Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
          </p>
        </div>
        <div className="gdpr-modal-footer">
          <button className="gdpr-modal-accept" onClick={onClose}>
            Entendido
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default GDPRModal;

